// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XSz_","colMin":"styles_colMin__1Pvqt"};